import { personInfoFrag } from '../../../../../../utils/type/person.common-type';

export const getSuggestionsFrag = `
    id
    dateFrom
    folderId
    serviceId
    person {
        ${personInfoFrag}
    }
    workData {
        ... on WorkDataSuggestionObject {
            type
            complaintType {
                daysToProcess
            }
        }
    }
`;
